import type { IconType } from "@/stories/atoms/Icon/Icon"
import type { EstimationFormContentProps } from "@/stories/organisms/Form/EstimationFrom/EstimationForm"
import { AgenceSite, DayName, DayNumber, Horaire, OpeningHoursSpecification, ResultDisplay } from "./agenceSite.types"
type Social = {icon: IconType, label: string, url: string}


export const getSocials = (agence: AgenceSite) => {
  const {lienFacebook, lienInstagram, lienLikedIn, lienTikTok, lienX} = agence
  return [
    ...(lienFacebook ? [{
      icon: 'facebook',
      label: 'facebook',
      url: lienFacebook
    }] as Social[] : []),
    ...(lienInstagram ? [{
      icon: 'instagram',
      label: 'instagram',
      url: lienInstagram
    }] as Social[] : []),
    ...(lienLikedIn ? [{
      icon: 'linkedin',
      label: 'linkedin',
      url: lienLikedIn
    }] as Social[] : []),
    ...(lienTikTok ? [{
      icon: 'tiktok',
      label: 'tiktok',
      url: lienTikTok
    }] as Social[] : []),
    ...(lienX ? [{
      icon: 'x-twitter',
      label: 'x (twitter)',
      url: lienX
    }] as Social[] : [])
  ]
}


const DAY_MAP: Record<DayNumber, DayName> = {
  1: "Monday", 2: "Tuesday", 3: "Wednesday", 4: "Thursday",
  5: "Friday",  6: "Saturday", 7: "Sunday",
}

export const convertToOpeningHoursSpecification = (
  horaires: Horaire[] | null | undefined
): OpeningHoursSpecification[] => {
  if (!horaires) return []
  const groups = new Map<string, { opens: string; closes: string; days: DayName[] }>();

  for (const h of horaires) {
    if (h.statut !== "ouvert" || h.debut === null || h.fin === null) continue;

    const key = `${h.debut}|${h.fin}`;
    if (!groups.has(key)) {
      groups.set(key, { opens: h.debut, closes: h.fin, days: [] });
    }
    groups.get(key)!.days.push(DAY_MAP[h.jour]);
  }

  return Array.from(groups.values()).map(({ opens, closes, days }) => ({
    "@type": "OpeningHoursSpecification",
    dayOfWeek: days.length === 1 ? days[0] : days,
    opens,
    closes,
  }));
}

// Estimation form context from the agency services:
// buy + rental → global, buy only → sell, rental only (rent or property management) → rent
export const getEstimationContext = (
  { activerServiceAchat, activerServiceLocation, activerGestionLocative }: Pick<AgenceSite, 'activerServiceAchat' | 'activerServiceLocation' | 'activerGestionLocative'>
): EstimationFormContentProps['context'] => {
  const hasRental = activerServiceLocation || activerGestionLocative
  if (activerServiceAchat && hasRental) return 'global'
  if (activerServiceAchat) return 'sell'
  if (hasRental) return 'rent'
  return 'global'
}

/** affichage par défaut des résultats de recherche, choisi dans le CMS de l'agence */
export const getResultDisplay = (formatAffichage: ResultDisplay) => ({
  displayType: formatAffichage === 'liste' || formatAffichage === 'liste_carte' ? 'list' as const : 'grid' as const,
  displayMap: formatAffichage === 'grille_carte' || formatAffichage === 'liste_carte',
})
